import React from 'react';
import { cn } from "@/lib/utils";
import Marquee from "@/Components/magicui/marquee";

const reviews = [
  {
    name: "Mmeso Madu",
    username: "@MmesoMadu",
    body: "The school that made me who I am.#ABUNDANCEFOREVER 🥳",
    img: "https://avatar.vercel.sh/jack",
  },
  {
    name: "Ifeanyichukwu Cyprian",
    username: "@Ifeanyichukwu Cyprian Nnanyelugo",
    body: "Abundance Private Schools Cotonou , Benin Republic is an academic environment for excellence in knowledge , virtue and service .",
    img: "https://avatar.vercel.sh/jill",
  },
  {
    name: "Daniel C. Skillz",
    username: "@Daniel C. Skillz",
    body: "I work as a teacher in Abundance Private School and the journey has been educative, splendid and great so far. It's an honor to be among prestige tutors of this institution. Let's keep up the good work.",
    img: "https://avatar.vercel.sh/john",
  },
  {
    name: "Zara Somto",
    username: "@Zara Somto",
    body: "Abundance Private Schools is a place where the foundation of your children in every aspect of life are built both physically, spiritually, mentally,morally etc.The teachers make the learning experience valuable and dynamic and they create long lasting friendship and life changing memories.",
    img: "https://avatar.vercel.sh/jane",
  },
  {
    name: "Maduakor Dominic",
    username: "@Maduakor Dominic",
    body: "Abundance Private School is the best bilingual school in the Republic of Benin. I can testify as an alumnus and I highly recommend it for anyone who wants their child to get the best education 🇧🇯🙏🏽",
    img: "https://avatar.vercel.sh/jenny",
  },
  {
    name: "Lokoyi Lokoyi",
    username: "@Lokoyi Lokoyi",
    body: "Looking for the best school that gives you the best quality education, educate both hearts and minds of your adorables???🤔🤔 Yes, this is the school. Glad to be a partner🤗",
    img: "https://avatar.vercel.sh/james",
  },
];

const firstRow = reviews.slice(0, reviews.length / 2);
const secondRow = reviews.slice(reviews.length / 2);

const ReviewCard = ({
  img,
  name,
  username,
  body,
}) => {
  return (
    <figure
      className={cn(
        "relative w-64 cursor-pointer overflow-hidden rounded-xl border p-4",
        // light styles
        "border-gray-950/[.1] bg-gray-950/[.01] hover:bg-gray-950/[.05]",
        // dark styles
        "dark:border-gray-50/[.1] dark:bg-gray-50/[.10] dark:hover:bg-gray-50/[.15]",
      )}
    >
      <div className="flex flex-row items-center gap-2">
        <img className="rounded-full" width="32" height="32" alt="" src={img} />
        <div className="flex flex-col">
          <figcaption className="text-sm font-medium dark:text-black">
            {name}
          </figcaption>
          <p className="text-xs font-medium dark:text-gray-800">{username}</p>
        </div>
      </div>
      <blockquote className="mt-2 text-sm">{body}</blockquote>
    </figure>
  );
};

const Testi = () => {
  return (
    <div className="relative flex h-[500px] w-full flex-col items-center justify-center overflow-hidden rounded-lg border bg-background md:shadow-lg">
      <h2 className="text-3xl font-bold text-center mt-4 mb-8 text-gray-900 dark:text-gray-950">
        Discover Our Community's Voices!
      </h2>
      <Marquee pauseOnHover className="[--duration:20s]">
        {firstRow.map((review) => (
          <ReviewCard key={review.username} {...review} />
        ))}
      </Marquee>
      <Marquee reverse pauseOnHover className="[duration:20s]">
        {secondRow.map((review) => (
          <ReviewCard key={review.username} {...review} />
        ))}
      </Marquee>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-white dark:from-background"></div>
      <div className="pointer-events-none absolute inset-y-0 right-0 w-1/3 bg-gradient-to-l from-white dark:from-background"></div>
    </div>
  );
}

export default Testi;

